import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    subMenuBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '50px',
        width: '100%',
        top: '81px',
        zIndex: 1000,
        left: '0px',
        backgroundColor: theme.palette.primary.main,
        '& span': {
            margin: '0 10px',
            fontSize: '14px',
        },
        [theme.breakpoints.up('sm')]: {
            top: '90px',
        },
        [theme.breakpoints.up('md')]: {
            top: '100px',
        },
        position: 'fixed',
    },
    logo: {
        width: '120px',

        [theme.breakpoints.down('md')]: {
            width: '80px',
        },
    },
    logoSidebar: {
        width: '70%',
    },
}));
